"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Container_1 = __importDefault(require("@mui/material/Container"));
var StyledContainer = (0, styles_1.styled)(Container_1.default)(function () { return ({
    '@media (min-width: 1020px)': {
        paddingLeft: '110px !important',
        paddingRight: '110px !important',
    },
}); });
exports.default = StyledContainer;
